import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { IVideoPlaybackConfig } from './IVideoPlaybackConfig';

import { AccessControl } from 'rev-shared/media/MediaConstants';
import { UserContextService } from 'rev-shared/security/UserContext.Service';

import styles from './video-share-container.module.less';

@Component({
	selector: 'video-share-container',
	templateUrl: './VideoShareContainer.Component.html'
})
export class VideoShareContainerComponent {
	@Input() public mediaFeatures: any;
	@Input() public playbackPosition: number;
	@Input() public video: any;
	@Input() public playbackConfig: IVideoPlaybackConfig;

	public readonly styles = styles;

	public currentShareView: string = 'Link';

	constructor(
		private UserContext: UserContextService,
		private TranslateService: TranslateService
	) { }

	public get videoHasPublicAccess(): boolean {
		return this.video.accessControl === AccessControl.Public
			&& this.mediaFeatures.enablePublicVideoAccess;
	}

	public get videoHasEmbedAccessEnabled(): boolean {
		return this.video.isEmbedAccessEnabled;
	}

	public get sparkEnabled(): boolean {
		return this.mediaFeatures
			&& this.mediaFeatures.enableSpark
			&& this.UserContext.isUserAuthenticated();
	}
}
